export const API_PREFIX = '/zaimy/api';

export const BFF_API_ROUTES = {
  saveUserPhone: '/save-phone',
  getIndexedLocationsRoute: '/metadata/index',
} as const;

export const BFF_PROXY_API: Record<keyof typeof BFF_API_ROUTES, string> = {
  saveUserPhone: `${API_PREFIX}${BFF_API_ROUTES.saveUserPhone}`,
  getIndexedLocationsRoute: `${API_PREFIX}${BFF_API_ROUTES.getIndexedLocationsRoute}`,
};
